<template>
  <div class="list-filter">
    <div class="content has-border-bottom">
      <div class="name ellipsis">{{leftName}}</div>
      <div class="select" @click="onFilterClick">
        <span class="ellipsis">{{rightName}}</span>
        <i :class="['iconfont', `icon-arrow-${arrowUp ? 'up' : 'down'}`]"/>
      </div>
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'

export default {
  name: 'ListFilter',
  i18n,
  props: {
    arrowUp: Boolean,
    leftName: String,
    rightName: String
  },
  methods: {
    onFilterClick () {
      this.$emit('filter-click')
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.list-filter {
  flex: 0 0 auto;
  padding: 0 0 0 15px;
  font-size: 12px;
  color: var(--secondlyTitle);
  background-color: #fff;

  & .content {
    display: flex;
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
    padding-right: 15px;
  }

  & .name {
    flex: 1 1 auto
  }

  & .select {
    flex: 0 0 auto;
    margin-left: 10px;
    display: flex;
    text-align: right;
    overflow: hidden;

    & span {
      flex: 1 1 auto
    }

    & .iconfont {
      flex: 0 0 auto;
    }
  }
}
</style>
